import React from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import ClientsWalletsList from '../components/WalletsPage/ClientsWalletsList';
import PageHeader from '../layout/PageHeader';
import WalletCreateModal from '../components/WalletCreateModal/WalletCreateModal';
import { identity } from "../utils/getIdentity";

const MerchantClientsPage = ({
   userRole,
   networkFilter
}) => {
  const { merchantId } = useParams();
  const WalletCreateComponent = () => (
    <WalletCreateModal
      merchantId={merchantId}
      typeWallet="user"
      createMode="type"
      filtersFormName="clientsWalletsFilters"
      networkFilter={networkFilter}
    />
  );


  return (
    <>
      <PageHeader showBackButton={userRole.includes('corporate')} CreateModalComponent={WalletCreateComponent} />
      <div className={`component component-${identity}`}>
        <ClientsWalletsList
          formName="clientsWalletsFilters"
          merchantId={merchantId}
          typeWallet="user"
          networkFilter={networkFilter}
        />
      </div>
    </>
  );
};

const mapStateToProps = state => ({
  userRole: state.user.data.roles,
  networkFilter: state.networkFilter,
});

export default connect(mapStateToProps)(MerchantClientsPage);
